import { useEffect, useState } from "react";
import axios from "axios";
import { apiClient } from '../config/apiConfig';
import { FiSearch, FiEdit, FiSave, FiX } from "react-icons/fi";
import { FiPhone, FiSend } from 'react-icons/fi';

interface Order {
  orderId: number;
  customerName: string;
  status: string;
  orderDate: string;
  totalAmount: number;
}

const AdminOrders = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<Order[]>([]);
  const [searchOrderId, setSearchOrderId] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [editOrderId, setEditOrderId] = useState<number | null>(null);
  const [editedStatus, setEditedStatus] = useState("");
  const customerId = localStorage.getItem("customerId");
  // ✅ Fetch all orders
  useEffect(() => {
    if (!customerId) return;
    apiClient
      .get(`/Orders/GetOrders/${customerId}`)
      .then((res) => {
        setOrders(res.data);
        setFilteredOrders(res.data);
      })
      .catch((err) => console.error("Error fetching orders:", err));
  }, []);

  // ✅ Search handler
  const handleSearch = () => {
    let result = orders;
    if (searchOrderId) {
      result = result.filter((o: Order) =>
        o.orderId.toString().includes(searchOrderId)
      );
    }
    if (searchStatus) {
      result = result.filter(
        (o: Order) => o.status.toLowerCase() === searchStatus.toLowerCase()
      );
    }
    setFilteredOrders(result);
  };

  // ✅ Edit mode activate
  const handleEdit = (orderId: number, currentStatus: string) => {
    setEditOrderId(orderId);
    setEditedStatus(currentStatus);
  };

  // ✅ Cancel editing
  const handleCancel = () => {
    setEditOrderId(null);
    setEditedStatus("");
  };

  // ✅ Save updated status
  const handleSave = (orderId: number) => {
    apiClient
      .put(`/Orders/UpdateStatus/${orderId}`, {
        status: editedStatus,
      })
      .then(() => {
        const updated = orders.map((o: Order) =>
          o.orderId === orderId ? { ...o, status: editedStatus } : o
        );
        setOrders(updated);
        setFilteredOrders(updated);
        setEditOrderId(null);
        setEditedStatus("");
        alert("Order status updated successfully!");
      })
      .catch((err) => console.error("Error updating order:", err));
  };

  return (
    <div className="container py-5">
      <div className="py-1 bg-primary">
        <div className="container">
          <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
            <div className="col-lg-12 d-block">
              <div className="row d-flex">
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiPhone size={12} color="white" /></div>
                  <span className="text">+91 9148761750</span>
                </div>
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiSend size={12} color="white" /></div>
                  <span className="text">care@fhome.shop</span>
                </div>
                <div className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right">
                  <span className="text">3-5 Business days delivery &amp; Free Returns</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>

          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active"><a href="/admin/categories" className="nav-link">AdminCategories</a></li>
              <li className="nav-item active"><a href="/admin/deal-of-the-day" className="nav-link">DealOfTheDay</a></li>
              <li className="nav-item"><a href="/admin" className="nav-link">Admin Products</a></li>
              <li className="nav-item"><a href="/admin/orders" className="nav-link">Admin Orders</a></li>
            </ul>
          </div>
        </div>
      </nav>
      <h3 className="mb-4">🧾 Order List Page</h3>

      {/* ✅ Search Bar */}
      <div className="card p-3 mb-4 shadow-sm">
        <div className="row align-items-center">
          <div className="col-md-4">
            <label>Status</label>
            <select
              className="form-control"
              value={searchStatus}
              onChange={(e) => setSearchStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="Order Placed">Order Placed</option>
              <option value="Shipped">Shipped</option>
              <option value="Delivered">Delivered</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>Order ID</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Order ID"
              value={searchOrderId}
              onChange={(e) => setSearchOrderId(e.target.value)}
            />
          </div>
          <div className="col-md-2 mt-3 mt-md-0">
            <button className="btn btn-success w-100" onClick={handleSearch}>
              <FiSearch /> Search
            </button>
          </div>
        </div>
      </div>

      {/* ✅ Order List */}
      {filteredOrders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        filteredOrders.map((order) => (
          <div key={order.orderId} className="card mb-3 shadow-sm p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p><strong>Order ID:</strong> {order.orderId}</p>
                <p><strong>Customer Name:</strong> {order.customerName}</p>
                <p><strong>Order Date:</strong> {new Date(order.orderDate).toLocaleDateString()}</p>
                <p><strong>Total Amount:</strong> ₹{order.totalAmount}</p>

                {/* ✅ Edit Mode */}
                {editOrderId === order.orderId ? (
                  <div className="d-flex align-items-center">
                    <label className="me-2"><strong>Status:</strong></label>
                    <select
                      className="form-select me-3"
                      style={{ width: "180px" }}
                      value={editedStatus}
                      onChange={(e) => setEditedStatus(e.target.value)}
                    >
                      <option value="Order Placed">Order Placed</option>
                      <option value="Shipped">Shipped</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                    <button
                      className="btn btn-success me-2"
                      onClick={() => handleSave(order.orderId)}
                    >
                      <FiSave />
                    </button>
                    <button className="btn btn-danger" onClick={handleCancel}>
                      <FiX />
                    </button>
                  </div>
                ) : (
                  <p>
                    <strong>Status:</strong> {order.status}{" "}
                    <FiEdit
                      className="text-primary ms-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEdit(order.orderId, order.status)}
                    />
                  </p>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
export default AdminOrders;

